import React from 'react';

import Heading from '../components/Headers/Heading';
import AboutText from '../components/AboutComponents/AboutText';
import ImageSection from '../components/Sections/ImageSection';
import TextContent, { TextContentAboutPage, AboutMultiSection } from '../components/TextContent/TextContent';
import Testimonial from '../components/Testimonial/Testimonial';
import aboutheaderimage from '../assets/images/about-header.webp';
import Art from '../components/Misc/Art';
import illustration from '../assets/images/art_1.png';
import { imageSectionData } from '../Data/ImageSectionData';

import logo from '../assets/images/logo.png';
import CallToAction from '../components/Misc/CallToAction';

function About() {
    return (
        <>
            <div className="page-header position-relative">
                <Heading 
                    heading={<h1>About Dr. Mohammed Audu Rehab Centre</h1>}
                    headingClass="heading-very-large dark-1"
                    paragraph="Dr. Mohammed Audu Rehab Centre was established to address the growing need for structured and ethical rehabilitation services in Nigeria. We are committed to restoring dignity, stability, and hope to individuals struggling with substance use and related challenges."
                    paragraphClass="dark-2"
                    WrapperComponent={(props) => {
                        return (
                            <div className="page-header-top">
                                <div className="container">
                                    {props.children}
                                </div>
                            </div>
                        )
                    }}
                />
                <div className="page-header-bottom">
                    <div className="single-image">
                        <img src={aboutheaderimage} alt="about-header" />
                    </div>
                    <Art art={illustration} type="1" />
                </div>
            </div>
            <AboutText image={logo} content="We are a passionate team committed to restoring lives, healing families, and building a supportive community for long-term recovery." />
            {imageSectionData.map((imageSection, index) => (
                <ImageSection
                    heading={imageSection.heading}
                    content={imageSection.content}
                    image={imageSection.image}
                    title={imageSection.title}
                    iconNum={imageSection.iconNum}
                    reverse={(index + 1) % 2 === 0}
                    icon={imageSection.icon}
                    key={index}
                />
            ))}

            <TextContentAboutPage />
            <AboutMultiSection />
            <Testimonial type="5" />
            <CallToAction 
                wrapperClass='bg-main'
                heading={
                    <>
                        Compassionate Care. 
                        <br />
                        Professional Support.
                    </>
                }
                buttonText="Our Programs"
                buttonLink="/programs"
                buttonType="2"
                artwork={null}
            />
            <CallToAction 
                wrapperClass='projects-footer bg-black'
                headingClass='light-1'
                heading={
                    <>Need Support? Reach out to us today.</>
                }
                buttonText="Get Support"
                buttonLink="/contact"
                buttonType="1"
            />
        </>
    );
}

export default About;
